import { CheckCircle, Menu } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ManagerBottomNavigationBar from '../../../components/ManagerBottomNavigationBar';
import ManagerTaskApprovalCard from '../../../components/ManagerTaskApprovalCard';
import SidebarMenu from '../../../components/SidebarMenu';
import useManagerApprovalsStore from '../../../store/managerApprovals';

export default function ManagerApprovalsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const {
    approvals,
    isLoading,
    error,
    fetchApprovals,
    approveTask,
    rejectTask,
  } = useManagerApprovalsStore();

  useEffect(() => {
    fetchApprovals();
  }, [fetchApprovals]);

  return (
    <div className="bg-white min-vh-100 d-flex flex-column">
      <Container fluid className="flex-grow-1 pb-5">
        {/* Sticky Header */}
        <div
          className="sticky-top bg-white"
          style={{
            zIndex: 1020,
            borderBottom: '1px solid rgba(0,0,0,0.1)',
          }}
        >
          <Row className="align-items-center p-4 pb-2">
            <Col xs="auto">
              <Menu
                size={24}
                className="text-dark"
                onClick={() => setShowSidebar(true)}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col className="text-center">
              <h2 className="text-dark h5 fw-bold mb-0">
                {t('manager.approvals.title')}
              </h2>
            </Col>
            <Col xs="auto" style={{ width: '24px' }} />
          </Row>
        </div>

        {/* Content */}
        <div className="px-0 pt-3">
          {isLoading && (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          )}

          {error && <Alert variant="danger">{error}</Alert>}

          {!isLoading && !error && approvals.length === 0 && (
            <div className="text-center py-5">
              <div className="mb-4">
                <CheckCircle size={64} className="text-success" />
              </div>
              <h5 className="text-muted mb-3">
                {t('manager.approvals.noRequests')}
              </h5>
              <p className="text-muted">
                {t('manager.approvals.emptyStateDescription')}
              </p>
              <Button
                variant="primary"
                className="mt-3"
                onClick={() => navigate('/manager/home')}
              >
                {t('manager.approvals.backToHome')}
              </Button>
            </div>
          )}

          {!isLoading && !error && approvals.length > 0 && (
            <div className="mb-4">
              <h5 className="fw-bold mb-3">
                {t('manager.approvals.pendingRequests', {
                  count: approvals.length,
                })}
              </h5>
              {approvals.map(approval => (
                <ManagerTaskApprovalCard
                  key={approval._id}
                  approval={approval}
                  onApprove={approveTask}
                  onReject={rejectTask}
                />
              ))}
            </div>
          )}
        </div>
      </Container>

      <SidebarMenu show={showSidebar} onHide={() => setShowSidebar(false)} />
      <ManagerBottomNavigationBar />
    </div>
  );
}
